import { Box, Drawer } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '../../../components/Button/Button';
import DrawerHeader from '../../../components/Drawer/components/DrawerHeader';
import HistorialDocumentoContainer from '../HistorialDocumentoContainer/HistorialDocumentoContainer';

function HistorialDocumentoDrawer({ openDrawer, handleCloseDrawer }: any) {
    return (
        <Drawer anchor="right" open={!!openDrawer} onClose={handleCloseDrawer}>
            <Box className="drawer-container">
                <DrawerHeader
                    onClose={handleCloseDrawer}
                    icon={<ArrowBackIcon />}
                    title="Historial del documento"
                />
                <Box className="drawer-body">
                    <HistorialDocumentoContainer docId={openDrawer} />
                </Box>
                <Box className="drawer-actions">
                    <Button onClick={handleCloseDrawer}>Volver</Button>
                </Box>
            </Box>
        </Drawer>
    );
}

export default HistorialDocumentoDrawer;
